import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

export function OMSLoading(props) {
  return (
    props.loading == true && (
      <div className="loadingContiner">
        <div className="defaultSpinner"></div>
      </div>
    )
  );
}
